import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { Svg } from "../svg/Svg";
export const MinusIcon = React.forwardRef((props, ref) => (_jsx(Svg, { "data-testid": "MinusIcon", ...props, ref: ref, children: _jsx("path", { fill: "currentColor", d: "M 11.6738 8.27832L 4.33496 8.27832L 4.33496 6.95117L 11.6738 6.95117L 11.6738 8.27832Z" }) })));
MinusIcon.displayName = "MinusIcon";
